export default "__VITE_ASSET__rf19nZHH__"